import React from 'react'
import PropTypes from 'prop-types'
import { useSelector } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const PrivateLandlordRoute = ({ component: Component, ...rest }) => {
  const isLoggedIn = useSelector(state => state.auth.isLoggedIn)
  const isLandlord = useSelector(state => state.auth.currentUser.isLandlord)

  return (
    <Route {...rest} component={(props) => (
      isLoggedIn && isLandlord ? (
        <Component {...props} />
      ) : (
        <Redirect to='/login' /> // Take them to their logged out home view
      )
    )} />
  )
}

PrivateLandlordRoute.propTypes = {
  component: PropTypes.object
}

export default PrivateLandlordRoute
